module.exports = __webpack_public_path__ + "img/f2.702dc255.png";